import { avaliahubApiUrl } from '../../global';

/**
 * The bank dossier of regular work orders lives in the avaliahub-api. Without
 * its URL the feature is off: no request is made and the screens keep the
 * previous behavior (mock or nothing). No fallback to the control center,
 * which does not serve these routes. CRA inlines the variable at build time.
 */
export const bankDossierApiUrl = avaliahubApiUrl;

export const isBankDossierApiEnabled = bankDossierApiUrl !== '';
